export default "__VITE_PUBLIC_ASSET__9d830c4d__"